import {
  Cached,
  ChainedMapper,
  FirestoreEntity,
  Mapper,
  VersionMapper,
  getFirestoreEntityVersionFn,
} from '../@harmony';
import { AnyGalleryEntityVersion, GalleryDto, GalleryEntity } from './data/entities/gallery.entity';
import { Gallery } from './domain/models/gallery.model';
import {
  GalleryDtoToGalleryEntityMapper,
  GalleryEntityToGalleryMapper,
} from './domain/mappers/gallery.mapper';

export abstract class GalleryCommonProvider {
  abstract provideGalleryEntityVersionsMapper(): Mapper<
    FirestoreEntity<AnyGalleryEntityVersion>,
    FirestoreEntity<GalleryEntity>
  >;
  abstract provideGalleryDtoToGalleryMapper(): Mapper<GalleryDto, Gallery>;
  abstract provideGalleryEntityToGalleryMapper(): Mapper<
    FirestoreEntity<AnyGalleryEntityVersion>,
    Gallery
  >;
}

export class GalleryCommonDefaultProvider implements GalleryCommonProvider {
  @Cached()
  public provideGalleryEntityVersionsMapper(): Mapper<
    FirestoreEntity<AnyGalleryEntityVersion>,
    FirestoreEntity<GalleryEntity>
  > {
    return new VersionMapper(getFirestoreEntityVersionFn, []);
  }

  @Cached()
  public provideGalleryDtoToGalleryMapper(): Mapper<GalleryDto, Gallery> {
    return new ChainedMapper<[GalleryDto, FirestoreEntity<GalleryEntity>, Gallery]>([
      new GalleryDtoToGalleryEntityMapper(),
      new GalleryEntityToGalleryMapper(),
    ]);
  }

  @Cached()
  public provideGalleryEntityToGalleryMapper(): Mapper<
    FirestoreEntity<AnyGalleryEntityVersion>,
    Gallery
  > {
    return new ChainedMapper([
      this.provideGalleryEntityVersionsMapper(),
      new GalleryEntityToGalleryMapper(),
    ]);
  }
}
